import { TransactionDto } from 'api/Transaction/Types/Transaction'
import classNames from 'classnames'

export function generateClassNameForReverseType(
  transaction: TransactionDto,
  type: 'date' | 'number' | 'content' = 'content'
): string {
  // means transaction type Reverse
  if (
    transaction?.type?.id === 680 ||
    transaction?.state?.id === 600 ||
    transaction.reverseTransaction
  ) {
    return classNames(`table-columns__${type}`, 'transaction-reversed')
  }
  return classNames(`table-columns__${type}`)
}

export function generateClassNameForDebitOrCreditTransactionType(type: {
  id: number
  name: string
}): string {
  // means transaction type debit
  if (type.id === 200) {
    return classNames('transaction__deposit')
  }
  return classNames(`transaction__debit`)
}
